import styled from 'styled-components';

import { NewStyleColor } from '../../../../utils/styles-constants';
import { PAGE_PADDING, editorScrollStyles } from '../../styles';

interface StyledBackgroundProps {
	url: string;
	color: string | undefined;
	isActive: boolean;
	isMobileApp: boolean;
	isHidden: boolean;
}

const getBackgroundStyles = (url: string, color: string | undefined, isActive: boolean): string => {
	if (!isActive) {
		return `background: ${color || ''} url(${url}) center / cover no-repeat;`;
	}

	return `
		background-image:
			linear-gradient(${NewStyleColor.Blue100}, ${NewStyleColor.Blue100}),
			linear-gradient(${NewStyleColor.Blue100}, ${NewStyleColor.Blue100}),
			linear-gradient(${NewStyleColor.Blue100}, ${NewStyleColor.Blue100}),
			linear-gradient(${NewStyleColor.Blue100}, ${NewStyleColor.Blue100}),
			${color || ''} url(${url});
		background-size:
			2px 100%,
			2px 100%,
			100% 2px,
			100% 2px,
			cover;
		background-position:
			0 0,
			calc(100% - ${PAGE_PADDING}px) 0,
			0 ${PAGE_PADDING}px,
			0 calc(100% - ${PAGE_PADDING}px),
			center;
		background-repeat:no-repeat;
	`;
};

const StyledBackground = styled('div')`
	flex: 1 1 auto;
	display: ${({ isHidden }: StyledBackgroundProps) => isHidden ? 'none' : 'flex'};
	flex-direction: column;
	padding: ${PAGE_PADDING}px;
	padding-left: 0;
	overflow: auto;

	${({ url, color, isActive }: StyledBackgroundProps) => getBackgroundStyles(url, color, isActive)}

	background-clip: content-box;

	${({ isMobileApp }: StyledBackgroundProps) => !isMobileApp && editorScrollStyles}
`;

export {
	StyledBackground,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Page/Background/styles.ts